export default "__VITE_ASSET__CEjGmIzK__"